module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("经办人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.applicant.name))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fillDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.applicant.rankName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("借款信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据编号")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.recCode),
      callback: function($$v) {
        _vm.recCode = $$v
      },
      expression: "recCode"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loanStatusStr))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departmentName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款金额"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    on: {
      "on-blur": _vm.transferChinese
    },
    model: {
      value: (_vm.loanMoney),
      callback: function($$v) {
        _vm.loanMoney = $$v
      },
      expression: "loanMoney"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款金额大写")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loanMoneyChinese))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预计还款日期"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.willReturnDate) + "\n          "), _c('a', {
    on: {
      "click": _vm.chooseDate
    }
  }, [_c('img', {
    staticClass: "icon right",
    attrs: {
      "src": require("../../../assets/icon/date-blue.png"),
      "width": "18",
      "height": "18"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属业务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.businessChoosed.businessName) + "\n        ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.clearBusiness
    }
  }, [_vm._v("清除")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("用途")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "title": "",
      "max": 100,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanReason),
      callback: function($$v) {
        _vm.loanReason = $$v
      },
      expression: "loanReason"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("附件")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.chooseFile
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn-file",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "box"
    }
  }), _vm._l((_vm.fileShowList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "img-box"
    }, [_c('img', {
      staticClass: "icon-close",
      attrs: {
        "src": require("../../../assets/icon/close-blue.png")
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(key)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img-part",
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _c('p')], 2)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("收付款信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款人/单位")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.payee),
      callback: function($$v) {
        _vm.payee = $$v
      },
      expression: "payee"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款银行")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanBankName),
      callback: function($$v) {
        _vm.loanBankName = $$v
      },
      expression: "loanBankName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款账号")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanBankNo),
      callback: function($$v) {
        _vm.loanBankNo = $$v
      },
      expression: "loanBankNo"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "pay-type-td"
    }
  }, [_c('group', [_c('selector', {
    attrs: {
      "id": "pay-type-gp",
      "title": "",
      "options": _vm.payTypeList
    },
    model: {
      value: (_vm.payTypeVal),
      callback: function($$v) {
        _vm.payTypeVal = $$v
      },
      expression: "payTypeVal"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("记账单位"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "account-unit-td"
    }
  }, [_c('group', [_c('selector', {
    attrs: {
      "id": "account-unit-gp",
      "value-map": ['fsn', 'name'],
      "options": _vm.accountUnitList
    },
    on: {
      "on-change": _vm.onAccountUnitChange
    },
    model: {
      value: (_vm.accountUnitValue),
      callback: function($$v) {
        _vm.accountUnitValue = $$v
      },
      expression: "accountUnitValue"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款银行")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.bankAccount.FAccountName) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款账号")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.bankAccount.FAccountNo) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('x-textarea', {
    attrs: {
      "title": "",
      "max": 100,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-part",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "padding": "8px 10px 0px 0px"
    },
    attrs: {
      "slot": "label",
      "src": require("../../../assets/icon/close.png"),
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-input"
  }, [_c('p', [_c('x-input', {
    attrs: {
      "id": "businessName",
      "title": "业务名称",
      "placeholder": "    请输入",
      "show-clear": true
    },
    model: {
      value: (_vm.businessName),
      callback: function($$v) {
        _vm.businessName = $$v
      },
      expression: "businessName"
    }
  }, [_c('x-button', {
    staticClass: "dialog-btn",
    attrs: {
      "slot": "right",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchBusiness($event)
      }
    },
    slot: "right"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('p', [_c('group', [_c('selector', {
    attrs: {
      "value-map": ['name', 'name'],
      "title": "业务类型",
      "options": _vm.selectorList
    },
    model: {
      value: (_vm.selectorValue),
      callback: function($$v) {
        _vm.selectorValue = $$v
      },
      expression: "selectorValue"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-part"
  }, [(this.businessList.length > 0) ? _c('x-table', {
    staticStyle: {
      "background-color": "#fff",
      "width": "100%"
    },
    attrs: {
      "full-bordered": ""
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "dialog-title-tr"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("业务名称")]), _vm._v(" "), _c('td', [_vm._v("委托单位")]), _vm._v(" "), _c('td', [_vm._v("项目经理")]), _vm._v(" "), _c('td', [_vm._v("业务类型")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.businessList), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticClass: "dialog-switch-td"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.businessChoosed),
        expression: "businessChoosed"
      }],
      attrs: {
        "type": "radio",
        "name": ""
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.businessChoosed, item)
      },
      on: {
        "change": function($event) {
          _vm.businessChoosed = item
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.businessName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.consignorUnitNames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.managerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.flowType))])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "dialog-bottom-bar"
  }, [(this.businessList.length > 0) ? _c('span', [_c('x-button', {
    staticClass: "dialog-btn btn-prev",
    attrs: {
      "mini": "",
      "disabled": _vm.preStatus
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getPrePage($event)
      }
    }
  }, [_vm._v("上一页")]), _vm._v("\n          " + _vm._s(_vm.pageNum) + "/" + _vm._s(_vm.businessAllNum) + "页\n          "), _c('x-button', {
    staticClass: "dialog-btn btn-next",
    attrs: {
      "mini": "",
      "disabled": _vm.nextStatus
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getNextPage($event)
      }
    }
  }, [_vm._v("下一页")])], 1) : _vm._e(), _vm._v(" "), _c('x-button', {
    staticClass: "dialog-btn btn-confirm",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseBusiness($event)
      }
    }
  }, [_vm._v("确定")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3b22a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/finance/loanApply.vue
// module id = hYdT
// module chunks = 1